var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterFields(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "currentColor",
    d: "M5.5 13c0-.552.444-1 1-1h3c.552 0 1 .444 1 1 0 .552-.444 1-1 1h-3c-.552 0-1-.444-1-1zm-2-4c0-.552.446-1 .998-1h7.004c.551 0 .998.444.998 1 0 .552-.446 1-.998 1H4.498A.996.996 0 0 1 3.5 9zM1 4.5C1 3.672 1.675 3 2.498 3h11.004C14.329 3 15 3.666 15 4.5c0 .828-.675 1.5-1.498 1.5H2.498A1.495 1.495 0 0 1 1 4.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterFields);
export default __webpack_public_path__ + "static/media/filter-fields.0443d7e32519a029bd6b9620cf91d55f.svg";
export { ForwardRef as ReactComponent };